import { render, staticRenderFns } from "./AppRefresh.vue?vue&type=template&id=b116b0d2&scoped=true&"
import script from "./AppRefresh.vue?vue&type=script&lang=ts&"
export * from "./AppRefresh.vue?vue&type=script&lang=ts&"
import style0 from "./AppRefresh.vue?vue&type=style&index=0&id=b116b0d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b116b0d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
